import { BaseApiModel } from './BaseApiModel';
import { City } from './City';
import { Contract } from './Contract';
import { Address } from './Address';

export class Company extends BaseApiModel {
  public name: string;
  public logo: string;
  public contractIds: number[];
  public enabled: boolean;
  public modifiedAt: Date;
  public extraData: any;
  public cnpj: string;
  public Contracts: Array<Contract>;
  public Address: Address;
  public addressId: number;
  public City: {
    id: number;
    name: string;
    code: string;
    regionId: number;
    stateId: number;
    State: {
      id: number;
      abbreviation: string;
      name: string;
      regionId: number;
    };
  };
  public regionId: number;
  public stateId: number;
  public cityId: number;
  public address: Address;
  public createdAt: Date;
  public updatedAt: string;
  public deletedAt: string;
}
